import React from 'react'

const Footer = () => {
    return (
        <footer className="footer">
            <div>
                Copyright © 2021 Comms Calculator. For personal use only.
            </div>
        </footer>
    )
}

export default Footer
